import React from 'react';
import {Store} from '../../models/store.model';
import {StoreBasicFields} from './StoreBasicFields';
import {StoreContactFields} from './StoreContactFields';
import {StoreAdditionalFields} from './StoreAdditionalFields';

interface StoreFormFieldsProps {
  formData: Partial<Store>;
  onInputChange: (field: keyof Store, value: string) => void;
  onDeveloperChange: (developerId: number | null) => void;
  onFileChange: (field: keyof Store, file: File | File[] | null) => void;
  onRemoveExistingImage: (imageType: 'commercialRegisterImage' | 'taxCardImage' | 'profileImage' | 'storeImages', imageUrl: string) => void;
  removedImages: {
    commercialRegisterImage?: string;
    taxCardImage?: string;
    profileImage?: string;
    storeImages?: string[];
  };
}

export const StoreFormFields: React.FC<StoreFormFieldsProps> = ({
  formData,
  onInputChange,
  onDeveloperChange,
  onFileChange,
  onRemoveExistingImage,
  removedImages
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <StoreBasicFields
          formData={formData}
          onInputChange={onInputChange}
          onDeveloperChange={onDeveloperChange}
        />
        <StoreContactFields
          formData={formData}
          onInputChange={onInputChange}
        />
      </div>
      <StoreAdditionalFields
        formData={formData}
        onInputChange={onInputChange}
        onFileChange={onFileChange}
        onRemoveExistingImage={onRemoveExistingImage}
        removedImages={removedImages}
      />
    </div>
  );
};
